import { createContext, useContext, useEffect, useState } from "react";

// Available themes: Light and Dark only.
export const THEMES = [
  { id: "mui-light", label: "Light" },
  { id: "dark", label: "Dark" },
];

const THEME_IDS = THEMES.map((t) => t.id);

const ThemeContext = createContext({
  theme: "mui-light",
  themes: THEMES,
  setTheme: () => {},
  toggleTheme: () => {},
});

const STORAGE_KEY = "vyra-theme";

function getInitialTheme() {
  if (typeof window === "undefined") return "mui-light";
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && THEME_IDS.includes(stored)) return stored;
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "mui-light";
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const setTheme = (id) => {
    if (THEME_IDS.includes(id)) setThemeState(id);
  };

  // Cycle through the available themes (kept for the icon button use case).
  const toggleTheme = () => {
    setThemeState((prev) => {
      const idx = THEME_IDS.indexOf(prev);
      return THEME_IDS[(idx + 1) % THEME_IDS.length];
    });
  };

  return (
    <ThemeContext.Provider
      value={{ theme, themes: THEMES, setTheme, toggleTheme }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
